import React from "react";
//Material imports
import { ThemeProvider } from "@mui/material/styles";
//Limitless imports
import { useExpertTutorialsHook } from "@limitless/expert";
import { AnimateList, VerticalTabWithPaperContainer } from "@limitless/portal";
import Grid from "@limitless/modern/layout/Grid";
import Typography from "@limitless/modern/data-display/typography/Typography";
import { modernTheme } from "@limitless/themeing/modern-theme/ModernTheme";
import { useExpertProfileContext } from "@limitless/expert";
import VerticalTab from "@limitless/modern/navigation/vertical-tabs/VerticalTabs";
import { LoadingSpinner } from "@limitless/portal";
import TutorialItem from "../components/tutorials/TutorialItem";

const TutorialsScreen = () => {
    const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);
    const [selectedItem, setSelectedItem] = React.useState(0);

    const { tutorials } = useExpertTutorialsHook();
    const { data: tenantTutorialResource, loading } = tutorials;

    const { isDarkMode } = useExpertProfileContext();
    const theme = React.useMemo(() => modernTheme(isDarkMode ? "dark" : "light"), [isDarkMode]);

    const handleChange = (e, value) => {
        setSelectedTabIndex(value);
        // default first video tab expanded
        setSelectedItem(0);
    };

    const tutorialsTabs =
        Object.getOwnPropertyNames(tenantTutorialResource).length > 0
            ? Object.getOwnPropertyNames(tenantTutorialResource).map(item => ({ label: item, value: item }))
            : [];

    const renderPaperTutorialContent = React.useMemo(
        () => (
            <>
                <Typography variant="h6" sx={{ color: theme => theme.palette.grey[4], marginBottom: 1 }}>
                    {Object.getOwnPropertyNames(tenantTutorialResource)[selectedTabIndex]}
                </Typography>
                {Object.keys(tenantTutorialResource).map((item, index) => {
                    const videosList = tenantTutorialResource[item].videos;

                    return (
                        selectedTabIndex === index && (
                            <React.Fragment key={index}>
                                <AnimateList
                                    items={videosList}
                                    renderListItem={(listItem, listItemIndex) => {
                                        return (
                                            <TutorialItem
                                                tutorialItemValue={listItem}
                                                expanded={selectedItem === listItemIndex}
                                                handleAccorionChange={(e, isExpanded) => {
                                                    setSelectedItem(isExpanded ? listItemIndex : null);
                                                }}
                                                showDivider={
                                                    videosList.length > 1 && videosList.length !== listItemIndex + 1
                                                }
                                            />
                                        );
                                    }}
                                />
                            </React.Fragment>
                        )
                    );
                })}
            </>
        ),
        [tenantTutorialResource, selectedTabIndex, selectedItem]
    );

    if (loading) {
        return (
            <Grid container alignItems={"center"} justifyContent={"center"} mt={4}>
                <LoadingSpinner />
            </Grid>
        );
    }

    return (
        <ThemeProvider theme={theme}>
            {Object.getOwnPropertyNames(tenantTutorialResource).length > 0 && !loading ? (
                <VerticalTabWithPaperContainer
                    tabContent={<VerticalTab items={tutorialsTabs} onChange={handleChange} value={selectedTabIndex} />}
                    paperContent={renderPaperTutorialContent}
                />
            ) : (
                <Grid container mt={4} justifyContent="center">
                    <Typography variant="subtitle1">{"No tutorial videos are currently available"}</Typography>
                </Grid>
            )}
        </ThemeProvider>
    );
};

export default TutorialsScreen;
